import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Hi, I'm Adam`}</h1>
    <p>{`I am a student at UC- Boulder, pursuing a Masters degree in Electrical Engineering, with a focus on Embedded Systems and Power Electronics. See below for more information about me, as well as some of the projects I've worked on recently.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      